import { IinitialMyBrandsState } from 'interfaces/myBrands.interface';

const initialMyBrandsState: IinitialMyBrandsState = {
  myBrands: [],
  connectedBrands: [],
  pointsOfSaleConnected: [],
  isLoadingGetMyBrands: false,
  getMyBrands: () => Promise.resolve(false),
  removeFromMyBrand: () => Promise.resolve(false),
  removeFromMyBrandsMultiple: () => Promise.resolve(false),
  addToMyBrand: () => Promise.resolve({ ok: false, haveCatalog: false }),
  isLoadingAddToMyBrand: {
    isLoading: false,
    tenantId: '',
  },
  createNewBrand: () => Promise.resolve(false),
  addToMyBrandMultipleStatus: {
    haveBrandsToAdd: true,
    isLoading: false,
    totalBrands: 0,
    brandsToAdd: 0,
    brandsAdded: 0,
    isOpenModal: false,
  },
  addToMyBrandMultiple: () => Promise.resolve(),
  resendAssociationEmail: () => Promise.resolve(false),
  isLoadingResendAssociationEmail: {
    isLoading: false,
    tenantId: null,
  },
};

export default initialMyBrandsState;
